<template>
    <v-card>
        <v-card-title>
            <h2>Sections</h2>
        </v-card-title>
        <v-card-text>
            <ul v-if="sections.length > 0">
                <li
                    v-for="(section, index) in sections"
                    :key="index"
                >
                    <router-link :to="`/section/edit/${section.id}`">
                        {{ section.name }}
                    </router-link>
                </li>
            </ul>
            <p v-else>
                <span>
                    This step contains no sections.
                </span>
            </p>
        </v-card-text>
        <v-divider />
        <v-card-actions>
            <v-spacer />
            <v-btn to="/section/create">
                <v-icon
                    left
                    small
                >
                    fas fa-plus-circle
                </v-icon>
                Add Section
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState('stepEditor', [ 'name', 'sections', 'stepId']),
    }
};
</script>
